/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStarFill: {
  name: 'star-fill';
  data: string;
} = {
  name: 'star-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.91 2.586a1 1 0 0 0-1.82 0L8.834 7.548l-5.91.455a1 1 0 0 0-.631 1.704L6.4 13.815l-1.375 5.96a1 1 0 0 0 1.421 1.12L12 18.117l5.553 2.776a1 1 0 0 0 1.421-1.119l-1.375-5.96 4.108-4.108a1 1 0 0 0-.63-1.704l-5.911-.455-2.256-4.962Z" fill="currentColor"/></svg>`,
};
